export const formatFee = (estimatedFees: number, variant?: string, currency = 'USD'): string => {
  const variantString = variant ? `${variant} -` : '';
  return `${variantString} ${currency} ${estimatedFees.toLocaleString()}`;
};
